export default __webpack_public_path__ + "static/media/fsiRealCase2-en-mobile.1e787dcf.jpg";